<template>
  <div class="min-h-screen flex">
    <!-- Left: Brand panel -->
    <div class="hidden lg:flex lg:w-[58%] relative overflow-hidden auth-brand">
      <div class="absolute inset-0 bg-gradient-to-br from-[#1a3a6b] via-[#1e4d8f] to-[#2563eb]" />

      <div class="absolute inset-0 opacity-10" style="background-image: radial-gradient(circle at 2px 2px, rgba(255,255,255,0.3) 1px, transparent 0); background-size: 40px 40px;" />

      <div class="absolute top-[15%] left-[10%] w-64 h-64 rounded-full bg-white/5 blur-3xl animate-float-slow" />
      <div class="absolute bottom-[20%] right-[15%] w-80 h-80 rounded-full bg-blue-400/10 blur-3xl animate-float-slow" style="animation-delay: -3s" />
      <div class="absolute top-[50%] left-[50%] w-40 h-40 rounded-full bg-cyan-300/5 blur-2xl animate-float-slow" style="animation-delay: -7s" />

      <div class="relative z-10 flex flex-col justify-between w-full p-12">
        <div>
          <img :src="$logo" :alt="$appName" class="h-9 w-auto brightness-0 invert" />
        </div>

        <div class="max-w-md">
          <div class="mb-8">
            <div class="flex items-center gap-3 mb-6">
              <div class="w-14 h-14 rounded-2xl bg-white/10 backdrop-blur-sm flex items-center justify-center">
                <svg class="w-7 h-7 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
                  <path d="M4.9 19.1C1 15.2 1 8.8 4.9 4.9"/><path d="M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.4"/><circle cx="12" cy="12" r="2" fill="currentColor"/><path d="M16.2 7.8c2.3 2.3 2.3 6.1 0 8.4"/><path d="M19.1 4.9C23 8.8 23 15.2 19.1 19.1"/>
                </svg>
              </div>
              <div class="flex gap-1">
                <div class="w-1 h-8 rounded-full bg-white/20 animate-eq-1" />
                <div class="w-1 h-8 rounded-full bg-white/30 animate-eq-2" />
                <div class="w-1 h-8 rounded-full bg-white/20 animate-eq-3" />
                <div class="w-1 h-8 rounded-full bg-white/15 animate-eq-1" style="animation-delay: 0.2s" />
                <div class="w-1 h-8 rounded-full bg-white/25 animate-eq-2" style="animation-delay: 0.4s" />
              </div>
            </div>
          </div>

          <h1 class="text-3xl font-bold text-white leading-tight">
            Livestream Management<br>
            <span class="text-blue-200">Platform</span>
          </h1>
          <p class="text-base text-blue-200/70 mt-4 leading-relaxed">
            Manage your live channels, recordings, and media content. Publish to multiple platforms from one place.
          </p>

          <div class="flex flex-wrap gap-2 mt-8">
            <span class="px-3 py-1.5 rounded-full text-xs font-medium bg-white/10 text-white/80 backdrop-blur-sm">Live Streaming</span>
            <span class="px-3 py-1.5 rounded-full text-xs font-medium bg-white/10 text-white/80 backdrop-blur-sm">Video Editor</span>
            <span class="px-3 py-1.5 rounded-full text-xs font-medium bg-white/10 text-white/80 backdrop-blur-sm">Multi-format Export</span>
            <span class="px-3 py-1.5 rounded-full text-xs font-medium bg-white/10 text-white/80 backdrop-blur-sm">Analytics</span>
          </div>
        </div>

        <p class="text-sm text-blue-300/40">&copy; {{ year }} {{ $appName }}. All rights reserved.</p>
      </div>
    </div>

    <!-- Right: Form panel -->
    <div class="flex-1 flex items-center justify-center bg-white px-6 py-12 lg:px-12">
      <div class="w-full max-w-[420px]">
        <!-- Mobile logo -->
        <div class="flex items-center justify-center mb-10 lg:hidden">
          <img :src="$logo" :alt="$appName" class="h-9 w-auto" />
        </div>

        <slot />

        <!-- Mobile footer -->
        <p class="text-center text-xs text-gray-400 mt-8 lg:hidden">
          &copy; {{ year }} {{ $appName }}. All rights reserved.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthLayout',
  computed: {
    year() { return new Date().getFullYear() }
  }
}
</script>

<style>
@keyframes float-slow {
  0%, 100% { transform: translateY(0) scale(1); }
  50% { transform: translateY(-20px) scale(1.05); }
}
.animate-float-slow { animation: float-slow 12s ease-in-out infinite; }

@keyframes eq-1 { 0%, 100% { height: 8px; } 50% { height: 28px; } }
@keyframes eq-2 { 0%, 100% { height: 20px; } 50% { height: 10px; } }
@keyframes eq-3 { 0%, 100% { height: 14px; } 50% { height: 32px; } }
.animate-eq-1 { animation: eq-1 1.2s ease-in-out infinite; }
.animate-eq-2 { animation: eq-2 0.9s ease-in-out infinite; }
.animate-eq-3 { animation: eq-3 1.5s ease-in-out infinite; }
</style>
